import { render } from "./LichSu.vue?vue&type=template&id=79ca6aa4&scoped=true"
import script from "./LichSu.vue?vue&type=script&lang=js"
export * from "./LichSu.vue?vue&type=script&lang=js"

import "./LichSu.vue?vue&type=style&index=0&id=79ca6aa4&scoped=true&lang=css"

import exportComponent from "/Users/muoitrinh/Documents/Projects/BetmintonApp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ca6aa4"]])

export default __exports__